<template>
  <div class="management-contract">
    <el-card>
      <el-form ref="form" label-width="80px" inline style="margin-top: 30px">
        <el-form-item>
          <el-input
            v-model="memberInfo"
            placeholder="请输入标签名称"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="value"
            placeholder="请选择类别"
            style="width: 300px"
          >
            <el-option
              v-for="item in PatientLabel"
              :key="item.id"
              :label="item.diseaseName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-table
      :data="list"
      v-loading="loading"
      border
      style="width: 100%"
    >
      <el-table-column prop="typeName" label="类别名称"></el-table-column>
      <el-table-column prop="tabName" label="标签名称"></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        :formatter="formattercreateTime"
        width="200"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            @click.prevent="showCheckDialog(scope.row.id)"
            type="primary"
            size="small"
            >添加模板
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-wrapper" type="flex" justify="end">
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="page.pageNum"
        :page-size.sync="page.pageSize"
        :total="page.total"
        @current-change="onCurrentChange"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
import { Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      gridData: [],
      dialogTableVisible: false,
      memberInfo: "",
      list: [],
      loading: false,
      value: "",
      PatientLabel: [],
      multipleSelection: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      QuestionnaireList: [],
      QuestionnaireListId: [],
    };
  },
  mounted() {
    this.init();
    this.initPatientLabel();
  },
  methods: {
    query() {
      this.init();
    },
    initPatientLabel() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.health.manager.tab.type.select.condition",
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            _this.PatientLabel = obj.sanboDiseaseTypeList;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.getMedicineList();
    },
    showCheckDialog(id) {
      this.$router.push({ path: "healthyProgrammeList", query: { id: id } });
    },
    formatterisBind(row, column, code) {
      if (row.isBind == "1") {
        return "已绑定";
      } else if (row.isBind == "0") {
        return "未绑定";
      }
    },
    formattercreateTime(row) {
      return this.getDate(row.createTime);
    },
    getDate(tm) {
      var tt = new Date(parseInt(tm))
        .toLocaleString()
        .replace(/年|月/g, "-")
        .replace(/日/g, "        ");
      return tt;
    },
    init() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.health.manager.tab.type.list",
          source: "SANBOYUN",
          pageNum: _this.page.pageNum,
          pageSize: _this.page.pageSize,
          tabName: _this.memberInfo,
          typeId: _this.value,
          organizationId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosId,
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            _this.list = obj.sanboManagerTabTypeList;
            _this.page.total = obj.amout;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
  },
};
</script>

<style lang="scss">
.management-contract {
  .el-form {
    padding-top: 22px;
    border-top: 1px solid #f5f5f5;
  }
  .el-table {
    margin-top: 15px;
  }
  .pagination-wrapper {
    padding: 20px 0;
  }
  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
